"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var common_1 = require("stremio/common");
var components_2 = require("../components");
var URLsManager_1 = __importDefault(require("./URLsManager"));
var useStreamingOptions_1 = __importDefault(require("./useStreamingOptions"));
var Streaming_less_1 = __importDefault(require("./Streaming.less"));
var Streaming = (0, react_1.forwardRef)(function (_a, ref) {
    var profile = _a.profile, streamingServer = _a.streamingServer;
    var t = (0, react_i18next_1.useTranslation)().t;
    var toast = (0, common_1.useToast)();
    var _b = (0, useStreamingOptions_1.default)(streamingServer), streamingServerRemoteUrlInput = _b.streamingServerRemoteUrlInput, remoteEndpointSelect = _b.remoteEndpointSelect, cacheSizeSelect = _b.cacheSizeSelect, torrentProfileSelect = _b.torrentProfileSelect, transcodingProfileSelect = _b.transcodingProfileSelect;
    var onCopyRemoteUrl = (0, react_1.useCallback)(function () {
        if (streamingServer.remoteUrl) {
            navigator.clipboard.writeText(streamingServer.remoteUrl);
            toast.show({
                type: 'success',
                title: t('SETTINGS_REMOTE_URL_COPIED'),
                timeout: 2500,
            });
        }
    }, [streamingServer.remoteUrl]);
    return (react_1.default.createElement(components_2.Section, { ref: ref, label: 'SETTINGS_NAV_STREAMING' },
        react_1.default.createElement(URLsManager_1.default, null),
        streamingServerRemoteUrlInput.value !== null &&
            react_1.default.createElement(components_2.Option, { className: Streaming_less_1.default['configure-input-container'], label: 'SETTINGS_REMOTE_URL' },
                react_1.default.createElement("div", { className: Streaming_less_1.default['label'], title: streamingServerRemoteUrlInput.value }, streamingServerRemoteUrlInput.value),
                react_1.default.createElement(components_1.Button, { className: Streaming_less_1.default['configure-button-container'], title: t('SETTINGS_COPY_REMOTE_URL'), onClick: onCopyRemoteUrl },
                    react_1.default.createElement(react_2.default, { className: Streaming_less_1.default['icon'], name: 'link' }))),
        profile.auth !== null && profile.auth.user !== null && remoteEndpointSelect !== null &&
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_HTTPS_ENDPOINT' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, remoteEndpointSelect))),
        cacheSizeSelect !== null &&
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_SERVER_CACHE_SIZE' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, cacheSizeSelect))),
        torrentProfileSelect !== null &&
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_SERVER_TORRENT_PROFILE' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, torrentProfileSelect))),
        transcodingProfileSelect !== null &&
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_TRANSCODE_PROFILE' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, transcodingProfileSelect)))));
});
exports.default = Streaming;
